<template>
  <div
    class="absolute inset-0 w-full h-screen bg-cover bg-center"
    :style="{
      backgroundImage: 'url(' + require('../assets/background-1.jpg') + ')'
    }"
  >
    <div class="w-full h-screen flex justify-center content-center flex-wrap">
      <div class="w-full flex justify-center">
        <div class="text-black px-8 rounded-lg text-center border-2">
          <span class="font-bold text-4xl">Stefan de Bruin</span>
          <hr />
          <span class="font-thin text-2xl">Full stack developer</span>
        </div>
      </div>

      <div class="w-full flex justify-center mt-5">
        <a href="https://github.com/stefandb">
          <font-awesome-icon
            :icon="['fab', 'github']"
            size="5x"
            class="text-black border-2 border-white rounded-full p-1"
            v-tooltip.bottom="'github - stefandb'"
          />
        </a>
        <a href="https://bitbucket.org/%7Baba10776-c6d7-427a-a898-616c63629386%7D/">
          <font-awesome-icon
            :icon="['fab', 'bitbucket']"
            size="5x"
            class="text-black border-2 border-white rounded-full p-3 ml-5 mr-5"
            v-tooltip.bottom="'bitbucket - stefan_d_b'"
          />
        </a>
        <a href="https://twitter.com/stefan_d_b">
          <font-awesome-icon
            :icon="['fab', 'twitter']"
            size="5x"
            class="text-black border-2 border-white rounded-full p-3"
            v-tooltip.bottom="
              'twitter - stefan_d_b <br /> op persoonlijke titel'
            "
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {}
};
</script>
